import Select from 'react-select'
import {useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {ISelect} from '../../../coreGlobal/models/default'
import Swal from 'sweetalert2'
import {updateSaleApprovers} from '../core/_resquest'
import {UserRequest} from '../../../coreGlobal/models/user'
import {useAuth} from '../../../app/modules/auth'

type Props = {
  users: ISelect[]
  setUsers: React.Dispatch<React.SetStateAction<ISelect[]>>
  oldUser: UserRequest[]
  setOldUser: React.Dispatch<React.SetStateAction<UserRequest[]>>
  close: () => void
}
export const ReviewSalesModalForm = ({users, setUsers, oldUser, setOldUser, close}: Props) => {
  const {currentFranchise} = useAuth()
  const [loading, setLoading] = useState(false)

  const [selectedUser, setSelectedUser] = useState<ISelect | null>(null)

  const [newUser, setNewUser] = useState<ISelect[]>([])

  const addField = (user: ISelect | null) => {
    if (!user) return

    setNewUser((prev) => [...prev, user])

    setUsers((prev) => prev.filter((item) => item.value !== user.value))

    setSelectedUser(null)
  }

  const removeNewUser = (index: number) => {
    const user = newUser[index]

    setUsers((prev) => [...prev, user])

    setNewUser((prev) => prev.filter((_, i) => i !== index))
  }

  const removeOldUser = (index: number) => {
    const user = oldUser[index]

    setUsers((prev) => [
      ...prev,
      {
        value: String(user.id),
        label: user.name,
      },
    ])

    setOldUser((prev) => prev.filter((_, i) => i !== index))
  }

  async function submit() {
    await Swal.fire({
      title: 'Deseja atualizar os usuários aprovadores?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          const data = {
            users: [
              ...oldUser.map((value) => Number(value.id)),
              ...newUser.map((value) => Number(value.value)),
            ],
          }
          await updateSaleApprovers(currentFranchise?.id, data)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })
          closeModal()
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoading(false)
        }
      }
    })
  }
  function closeModal() {
    close()
  }
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_edit_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-1000px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h3 className='fw-bolder m-0'>Adicionar Aprovadores</h3>
              <div
                className='btn btn-icon btn-sm btn-active-icon-danger'
                data-kt-users-modal-action='close'
                onClick={closeModal}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body scroll-y'>
              <div className='row g-6 mb-6 mt-6 g-xl-9 mb-xl-9'>
                <div className='col-md-6 col-xxl-6'>
                  <Select
                    className='react-select-styled react-select-solid'
                    classNamePrefix='react-select'
                    options={users}
                    value={selectedUser}
                    onChange={(option) => setSelectedUser(option)}
                    placeholder='Selecione o usuário'
                  />
                </div>
                <div className='col-md-6 col-xxl-6'>
                  <button
                    disabled={!selectedUser}
                    onClick={(e) => {
                      e.preventDefault()
                      addField(selectedUser)
                    }}
                    className='btn btn-danger'
                  >
                    Adicionar Usuário
                  </button>
                </div>
              </div>
              <div className='row g-6 mb-6 mt-6 g-xl-9 mb-xl-9'>
                <div className='col-md-6 col-xxl-6'>
                  <div className='card '>
                    <div className='card-body flex-column'>
                      <span className='fs-4 d-flex flex-center text-gray-800 fw-bold mb-2'>
                        Usuários Cadastradas
                      </span>
                      <div className='d-flex flex-center flex-wrap mb-5'>
                        <table className='table table-row-dashed table-row-gray-300'>
                          <thead>
                            <tr className='fw-bolder fs-6 text-gray-800'>
                              <th>ID</th>
                              <th>Usuário</th>
                            </tr>
                          </thead>
                          <tbody>
                            {oldUser?.map((field, index) => (
                              <tr key={index} className='align-middle'>
                                <td>{field.id}</td>
                                <td>{field.name}</td>
                                <td>
                                  <button
                                    id={`${index}`}
                                    onClick={(e) => {
                                      removeOldUser(index)
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                  >
                                    <KTIcon iconName='trash' className='fs-3' />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 col-xxl-6'>
                  <div className='card '>
                    <div className='card-body flex-column'>
                      <span className='fs-4 d-flex flex-center text-gray-800 fw-bold mb-2'>
                        Usuário Adicionado
                      </span>
                      <div className='d-flex flex-center flex-wrap mb-5'>
                        <table className='table table-row-dashed table-row-gray-300'>
                          <thead>
                            <tr className='fw-bolder fs-6 text-gray-800'>
                              <th>ID</th>
                              <th>Usuário</th>
                            </tr>
                          </thead>
                          <tbody>
                            {newUser?.map((field, index) => (
                              <tr key={index} className='align-middle'>
                                <td>{field.value}</td>
                                <td>{field.label}</td>
                                <td>
                                  <button
                                    id={`${index}`}
                                    onClick={() => removeNewUser(index)}
                                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                  >
                                    <KTIcon iconName='trash' className='fs-3' />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <button type='reset' className='btn btn-secondary me-2' onClick={closeModal}>
                Cancelar
              </button>
              <button
                type='submit'
                className='btn btn-danger'
                disabled={loading}
                onClick={(e) => {
                  e.preventDefault()
                  submit()
                }}
              >
                {!loading && 'Salvar'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Salvando...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
